import { Badge } from "@mantine/core";

import { FLAG_PRIORITY_CHIP_TOKENS, FLAG_PRIORITY_CODINGS, FlagPriority } from "../constants/flags";

import FlagPriorityDot from "./FlagPriorityDot";

interface FlagPriorityBadgeProps {
  priority: FlagPriority;
  /**
   * The badge carries its own dot by default, per the status-chip triad in DESIGN.md §2.3. Surfaces
   * that already show a priority dot beside the flag name — the client list popover — turn it off
   * rather than repeating the same signal twice in one row.
   */
  withDot?: boolean;
}

export default function FlagPriorityBadge({ priority, withDot = true }: FlagPriorityBadgeProps) {
  const { surface } = FLAG_PRIORITY_CHIP_TOKENS[priority];

  return (
    <Badge
      fz="sm"
      radius="xl"
      leftSection={withDot ? <FlagPriorityDot priority={priority} /> : undefined}
      styles={{
        root: { backgroundColor: surface },
        label: {
          fontWeight: 500,
          textTransform: "none",
          color: "var(--mantine-color-dark-9)",
        },
      }}
    >
      {FLAG_PRIORITY_CODINGS[priority].display}
    </Badge>
  );
}
